import React from 'react'

const GoogleAd = ({ width = '100%', height = '100%' }) => {
  // const height = 500;
  const style = {
    height: height,
    width: width,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '90px',
    minWidth: '90px'
  }
  const placeholderStyle = {
    background: '#ffc',
    height: height,
    width: width,
    padding: '1rem',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1rem solid #ee7',
    color: 'rgba(0,0,0,0.25)',
    fontSize: '1.25rem',
    fontWeight: 'bold'

  }

  if (process.env.REACT_APP_GOOGLE_ADSENSE_USE_PLACEHOLDERS !== 'true') {
    return (
      <div style={style}>
        <ins
          className='adsbygoogle'
          style={{ display: 'block' }}
          data-ad-client={process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT}
          data-ad-slot={process.env.REACT_APP_GOOGLE_ADSENSE_SLOT}
          data-ad-format='auto'
        />
      </div>
    )
  } else {
    return (
      <div style={placeholderStyle}>
        PLACEHOLDER GOOGLE ADSENSE ADVERT
      </div>
    )
  }
}

export default GoogleAd
